<template>
<div class="basicStyle">
  <div class="mainBox">
     <div class="querySearch">
       <div class="title">
         备考通 <span class="fg">|</span> 帮助中心 
       </div>
       <div class="searchBox dfc">
        <el-input
          v-model="queryInfo.title"
          clearable
          size="small"
          placeholder="请输入问题关键词"
        ></el-input>
          <MyButton
          value="搜索"
          size="medium"
          icon="el-icon-search"
          type="1"
          @click="searchBt()"
        ></MyButton>
       </div>
     </div>
     <div class="home">
      <div class="contLeft">
        <div class="leftItem" :class="item.is_select ? 'leftItemAct' : ''" v-for="(item, index) in manual_cate_list" :key="index" @click="cateClick(item.id)">
          {{ item.name }}
        </div>  
      </div>
      <div v-if="tableList && tableList.length > 0" class="contRight">
        <div class="" v-if="searchShow && queryInfo.title">
          搜索“<span style="color:red;">{{ queryInfo.title }}</span>”的相关结果共{{ total }}条
        </div>
        <div v-else class="manual_cate_name">{{ manual_cate_name }}</div>
        <div class="rightItem" v-for="(item, index) in tableList" :key="index" @click="rightClick(item)">
          <i class="normal"></i>
          {{ item.title }}
        </div> 
         
        
        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryInfo.page"
            :page-sizes="[10, 30, 50, 80]"
            :page-size="queryInfo.limit"
            layout="total, sizes, prev, pager, next, jumper"
            :total="queryInfo.total"
          >
          </el-pagination>
        </div>
      </div>  
      <div v-else style="padding: 200px 0" class="contRight">
        <el-empty :image-size="100" description="暂无数据"></el-empty>
      </div>
    </div> 
  </div> 
</div>  
</template> 
<script>
import MyButton from "@/components/MyButton.vue";
import commonApi from "@/api/common";  
export default {
  name: "helpManualList", //帮助手册 
  components: {
    MyButton,
  },
  data() {
    return {
      queryInfo: {
        manual_cate_id: "0",
        title: "",
        limit: 10,
        page: 1,
        total: 0,
      }, 
      manual_cate_list: [],
      tableList: [],
      manual_cate_name: "",
      searchShow: false, 
    };
  },
  computed: { 

  },
  watch: {
      
  },
  created() {  
    if (this.$route.query.manual_cate_id) {   
      this.cateClick(this.$route.query.manual_cate_id)
    } 

    if (this.$route.query.id) {
      this.cateClick(this.$route.query.id)
    }

    this.getTobHelpManualList(0)
  },
  methods: {   
    rightClick(e){
      console.log("rightClick", e)  
      const routeUrl = this.$router.resolve({
        path: "/helpManualInfo",
        query: { id: e.id, manual_cate_id: e.manual_cate_id },
      })
      window.open( routeUrl.href, "_blank") 
    },
    searchBt(){ 
      if(this.queryInfo.title){
        this.searchShow = true
      }else{
        this.searchShow = false 
      }
      this.queryInfo.manual_cate_id = '0'
      this.getTobHelpManualList(1)
    },
    cateClick(e){
      this.manual_cate_list.forEach(item=>{
        item.is_select = 0
        if(e == item.id){
          item.is_select = 1 
        }
      }) 
      this.queryInfo.manual_cate_id = e
      this.queryInfo.title = ''
      this.getTobHelpManualList(0)
    },
    // 分页
    handleSizeChange(e) {
      //  e);
      this.queryInfo.limit = e;
      this.getTobHelpManualList(0);
    },
    handleCurrentChange(e) {
      this.queryInfo.page = e;
      this.getTobHelpManualList(0);
    },
    getTobHelpManualList(e){
      this.queryInfo.is_search = e 
      commonApi.getTobHelpManualList(this.queryInfo).then((res) => {
        if (res.code == 200) {
          console.log("getTobHelpManualList", res.data)
          this.manual_cate_list = res.data.manual_cate_list
          this.tableList = res.data.list
          this.manual_cate_name = res.data.manual_cate_name
          this.queryInfo.total = res.data.total
        }
      })
    }
  },
};
</script> 
<style lang="less" scoped> 
  .mainBox{
    padding: 20px; 
    border-radius: 10px; 

    .querySearch{
      display: flex;
      justify-content: space-between;
      align-items: center;
      .title{ 
        display: flex; 
        align-items: center;
        font-weight: bold;
        .fg{
          margin: 0 10px;
          line-height: 100%;
          margin-top: -3px;
        }
      }



    }

    .home {
      width: 100%; 
      box-sizing: border-box; 
      overflow-x: initial;
      display: flex;
      justify-content: space-between; 
      background: #f7f8fb;
      .contLeft {
        width: 15%;  
        padding: 20px; 
        background-color: #fff;
        margin-right: 20px;
        min-width: 250px;
        
        .leftItem{
          position: relative;
          color: #676767;
          padding-left: 55px;
          box-sizing: border-box;
          height: 36px;
          display: block;
          line-height: 36px;
          cursor: pointer;
 
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        } 
        .leftItem::before{
          display: block;
          position: absolute;
          content: "";
          width: 5px;
          height: 5px;
          background: #273758;
          left: 40px;
          top: 0;
          bottom: 0;
          margin: auto;
        }

        .leftItem:hover {
          color: #fff;
          background: #9583ff; 
        }
        .leftItemAct{
          color: #fff;
          background: #9583ff; 
        }
      }
      .contRight {
        width: 80%; 
        display: block;
        padding: 20px; 
        background-color: #fff; 

        .manual_cate_name{
          font-weight: bold;
          font-size: 16px; 
        }
        
        .rightItem{
          overflow: hidden;
          text-overflow: ellipsis;
          display: block;
          white-space: nowrap;
          padding: 24px 0 24px 0;
          box-sizing: border-box;
          border-bottom: 1px dashed #ccc;
          font-size: 16px;
          cursor: pointer;

          .normal{
            display: inline-block;
            width: 20px;
            height: 20px;
            margin-right: 0px;
            vertical-align: middle; 
            background: url(../../assets/img/iconPrit.png) -118px -6px no-repeat; 
          }
        } 
        .rightItem:hover {
          color: #9583ff;

          .normal{ 
            background: url(../../assets/img/iconPrit.png) -90px -6px no-repeat; 
          }
        }
      }
 
    }
  }

  .dfc{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
</style>
    